/** Активные публичные пути (без префикса /ru|/ky). */
export const appRoutePaths = [
  "/",
  "/services/incident",
  "/services/audit",
  "/services/retainer",
  "/services/projects",
  "/cases",
  "/about",
  "/contacts",
  "/delete-data",
  "/search",
] as const;

export type AppRoutePath = (typeof appRoutePaths)[number];

/** Старые URL → новый путь (клиентский Navigate; CF может дублировать в _redirects). */
export const legacyRedirects: ReadonlyArray<{ from: string; to: string }> = [
  { from: "/vps-hosting", to: "/" },
  { from: "/administrirovanie-serverov", to: "/services/retainer" },
  { from: "/server-support", to: "/services/retainer" },
  { from: "/devops-outsourcing", to: "/services/retainer" },
  { from: "/services/ddos-protection", to: "/services/projects" },
  { from: "/services/kubernetes-setup", to: "/services/projects" },
  { from: "/services/ci-cd-implementation", to: "/services/projects" },
  { from: "/services/llmops-private-ai", to: "/" },
  { from: "/vacancies", to: "/about" },
];
